/**
 * Calculate the percentage of interactions that have a given metric.
 * @param count          Count of all interactions.
 * @param metricCount    Count of interactions with a given metric.
 * @returns              Percentage calculation.
 */
export const calculateValue = (count: number | undefined, metricCount: number | undefined) => {
    if (typeof count !== "number" || typeof metricCount !== "number" || count === 0 || metricCount === 0) {
        return null;
    }

    return 100 * (metricCount / count);
};
